<template>
  <v-app style="background: #111722">
    <MovieNavBar />
    <v-main>
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
      <!--  -->
      <v-fab-transition>
        <!-- <div class="scroll_to_top" v-if="scrollButton"> -->
        <v-btn
          fab
          fixed
          bottom
          right
          v-show="scrollButton"
          v-scroll="showScrollBtn"
          color="#3d4b5e"
          @click="scrollToTop"
        >
          <v-icon color="white">mdi-chevron-up</v-icon>
        </v-btn>
        <!-- </div> -->
      </v-fab-transition>
    </v-main>
    <FooterMovie />
  </v-app>
</template>

<script>
// import Notification from "@/components/Cart/NotificationList.vue";
import MovieNavBar from "@/components/Movie/NavBarC";
import FooterMovie from "@/components/Movie/FooterC";

// eslint-disable-next-line no-unused-vars
import { mapActions, mapState } from "vuex";
export default {
  name: "App",
  data: () => ({
    //
    dialog: true,
    scrollButton: false,
  }),
  methods: {
    ...mapActions(["A_enableDialog"]),
    scrollToTop() {
      window.scrollTo({
        behavior: "smooth",
        top: 0,
      });
    },
    showScrollBtn() {
      scrollY > 200
        ? [(this.scrollButton = true)]
        : [(this.scrollButton = false)];
    },
  },
  mounted() {
    // console.log("mounted");
    this.A_enableDialog(true);
    setTimeout(() => {
      this.A_enableDialog(false);
    }, 1500);
    // let scrollBtn = document.querySelector(".scroll_to_top");
    // scrollY > 200
    //   ? [(this.scrollButton = true)]
    //   : [(this.scrollButton = false)];

    // window.onscroll = () => {
    //   scrollY > 200
    //     ? [(this.scrollButton = true)]
    //     : [(this.scrollButton = false)];
    // };
  },
  computed: {
    ...mapState({
      S_dialog: (store) => store.movie.S_dialog,
    }),
  },
  components: {
    MovieNavBar,
    FooterMovie,
  },
  
};
</script>

<style lang="scss">
a.next,
a.prev {
  span {
    color: rgb(163 169 177) !important;
  }
}
.scroll_to_top {
  position: fixed;
  bottom: 10px;
  right: 20px;
  z-index: 2;
}

.main_heading {
  margin-bottom: 60px;
  text-align: center;
  div {
    margin-bottom: 7px;
  }
  h1 {
    font-size: 40px;
    color: #cb834a;
    font-weight: 900;
    letter-spacing: 2px;
    margin-bottom: 10px;
  }
  span.special_design {
    position: relative;
    width: 200px;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      position: absolute;
      content: "";
      width: 50%;
      left: 0;
      height: 3px;
      top: 50%;
      z-index: 0;
      transform: translateY(-50%);
      background: linear-gradient(to right, transparent, #cb834a);
    }
    &::after {
      position: absolute;
      content: "";
      right: 0;
      width: 50%;
      height: 3px;
      top: 50%;
      z-index: 0;
      transform: translateY(-50%);
      background: linear-gradient(to left, transparent, #cb834a);
    }
    i {
      width: 7px;
      display: inline-block;
      height: 7px;
      background: #cb834a;
      transform: rotate(45deg);
    }
  }
}
// @import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Open+Sans:wght@300;400;500;600;700&family=Righteous&display=swap");
.special_font {
  // font-family: "Josefin Sans", sans-serif !important;
  font-family: "Righteous", cursive !important;
}
.nav_font {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 600 !important;
}
// * {
//   font-family: "Righteous", cursive !important;
// }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s, transform 1s;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}

.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease-in-out;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: scale(0.99);
}
</style>
